import { fetchEventsByDomain } from '@bizzabo/entities';

export async function getEventDetailsByDomain(): Promise<{
    eventUniqueName: string;
    isEventWhiteLabel: boolean;
    whitelabelPath?: string;
}> {
    const domain = window.location.host;
    const eventsbyDomain = await fetchEventsByDomain(domain);
    if (eventsbyDomain?.length) {
        const defaultEvent = eventsbyDomain[0];
        const eventByWhiteLabelPath = defaultEvent.onlyEventDomain
            ? defaultEvent
            : eventsbyDomain.find(({ whitelabelPath }) =>
                  window.location.pathname.startsWith(whitelabelPath)
              );
        return {
            eventUniqueName: eventByWhiteLabelPath['unique-name'],
            isEventWhiteLabel: true,
            whitelabelPath: !eventByWhiteLabelPath.onlyEventDomain
                ? eventByWhiteLabelPath.whitelabelPath
                : undefined,
        };
    }
    const pathnameValues = window.location.pathname.split('/');
    const eventUniqueName = pathnameValues[1] === 'venue' ? pathnameValues[2] : pathnameValues[1];
    return { eventUniqueName, isEventWhiteLabel: false };
}
